import { IconProps } from "@tabler/icons-react";
import { ComponentType } from "react";

import { Flex } from "#shared/view/components/Flex";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";

type Props = {
  title: string;
  Icon: ComponentType<IconProps>;
};

function SimpleDropzoneStatus({ title, Icon }: Props) {
  return (
    <Stack align="center" justify="center" gap="xxs">
      <Flex align="center" justify="center" gap="xxs">
        <Icon size="1.5rem" />
        <Text size="xl" inline fw={500}>
          {title}
        </Text>
      </Flex>
    </Stack>
  );
}

export default SimpleDropzoneStatus;
